module.exports = __webpack_public_path__ + "img/image138.950b25f.webp";